export default {
    find:   { method: 'get',    url: 'states' },
    create: { method: 'post',   url: 'states'},
    update: { method: 'put',    url: 'states/{id}'},
    delete: { method: 'delete', url: 'states/{id}'}
}